import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StarPurple500Icon(props: IconProps) {
    return <Icon {...props} iconKey={"star_purple500"}/>
}
